import { ArrowSquareOutIcon } from "@phosphor-icons/react/dist/csr/ArrowSquareOut";
import { Stack } from "@volca/ui/components/ui/stack";
import {
  QUICKBOOKS_BILL_STATUS,
  QUICKBOOKS_LINKED_EXISTING,
} from "@/accounts-payable/quickbooks-bill";
import type { ApQuickbooksBill } from "@/accounts-payable/types";
import { StatusBadge } from "./shared";

/**
 * Where an invoice's QuickBooks bill stands, for the invoice header, its side
 * panel and the Invoices table: the status, whether Volca only linked a bill
 * that was already there, and (with `showLink`) a link to open it. Nothing
 * when the invoice has no bill.
 */
export const QuickbooksBillStatus = ({
  bill,
  showLink = true,
}: {
  bill: ApQuickbooksBill | null | undefined;
  /** Off in table rows, where a click opens the invoice instead. */
  showLink?: boolean;
}) => {
  const meta = bill && QUICKBOOKS_BILL_STATUS[bill.status];
  if (!bill || !meta) return null;

  return (
    <Stack direction="row" gap={2} align="center" className="flex-wrap">
      <StatusBadge meta={meta} />
      {bill.linked_existing && (
        <StatusBadge meta={QUICKBOOKS_LINKED_EXISTING} />
      )}
      {/* A deleted bill has nothing left to open. */}
      {showLink && bill.url && bill.status !== "deleted" && (
        <a
          href={bill.url}
          target="_blank"
          rel="noopener noreferrer"
          className="inline-flex items-center gap-1 rounded-sm text-sm text-link hover:underline focus-visible:ring-1 focus-visible:ring-focus focus-visible:outline-hidden"
        >
          Open in QuickBooks
          <ArrowSquareOutIcon className="size-3" aria-hidden />
        </a>
      )}
    </Stack>
  );
};
